import { createGlobalStyle } from 'styled-components'

export default createGlobalStyle`
  #root {
    display: flex;
    flex: 1;
    min-height: 100%;
  }

  .custom-marker-label {
    background-color: #fff;
    border: 1px solid #e8e8e8;
    color: #fff;
    padding: 4px 8px;
  }

  .mr-8 {
    margin-right: 8px!important;
  }

  .table-striped tr {
    background-color: #fff;
  }
  .table-striped tr:nth-child(2n) {
    background-color: rgb(250, 250, 250);
  }

  @media print {
    .no-print, .no-print * {
        display: none !important;
    }
    .no-visible, .no-visible * {
      margin: 0;
      padding: 0;
      visibility: hidden !important;
    }
    ::-webkit-scrollbar {
      display: none;
    }
  }
`
